import React from 'react';
import './style/error.css';
import {Redirect} from "react-router-dom";

const Error = ({error}) => (
    <div className="fieldWrapper errorBlock messageBlock">
        {/401/.test(error) ? <Redirect to={'/auth' + window.location.search} /> : ''}
        <div className="errorContent" dangerouslySetInnerHTML={{__html: error}}/>
    </div>
);

export default Error;
